function cov_fummw3m42() {
  var path = "/app/src/components/credit-cards/credit-cards.tsx";
  var hash = "412d608b8da33573caeb7bdeb71b96967c6ce3df";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/credit-cards/credit-cards.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 48
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 9,
          column: 47
        }
      },
      "2": {
        start: {
          line: 11,
          column: 51
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "3": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 51
        }
      },
      "4": {
        start: {
          line: 14,
          column: 37
        },
        end: {
          line: 14,
          column: 78
        }
      },
      "5": {
        start: {
          line: 14,
          column: 50
        },
        end: {
          line: 14,
          column: 77
        }
      },
      "6": {
        start: {
          line: 15,
          column: 37
        },
        end: {
          line: 15,
          column: 78
        }
      },
      "7": {
        start: {
          line: 15,
          column: 50
        },
        end: {
          line: 15,
          column: 77
        }
      },
      "8": {
        start: {
          line: 16,
          column: 43
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "9": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 42
        }
      },
      "10": {
        start: {
          line: 19,
          column: 37
        },
        end: {
          line: 19,
          column: 78
        }
      },
      "11": {
        start: {
          line: 19,
          column: 50
        },
        end: {
          line: 19,
          column: 77
        }
      },
      "12": {
        start: {
          line: 20,
          column: 38
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 41
        }
      },
      "14": {
        start: {
          line: 24,
          column: 33
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "15": {
        start: {
          line: 34,
          column: 27
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "16": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 87,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 8
          },
          end: {
            line: 9,
            column: 47
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 51
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 44
          },
          end: {
            line: 14,
            column: 45
          }
        },
        loc: {
          start: {
            line: 14,
            column: 50
          },
          end: {
            line: 14,
            column: 77
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 15,
            column: 44
          },
          end: {
            line: 15,
            column: 45
          }
        },
        loc: {
          start: {
            line: 15,
            column: 50
          },
          end: {
            line: 15,
            column: 77
          }
        },
        line: 15
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 17,
            column: 42
          }
        },
        line: 17
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 19,
            column: 44
          },
          end: {
            line: 19,
            column: 45
          }
        },
        loc: {
          start: {
            line: 19,
            column: 50
          },
          end: {
            line: 19,
            column: 77
          }
        },
        line: 19
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 41
          }
        },
        line: 21
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 34,
            column: 27
          },
          end: {
            line: 34,
            column: 28
          }
        },
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 88,
            column: 1
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 19
          }
        }, {
          start: {
            line: 45,
            column: 23
          },
          end: {
            line: 45,
            column: 48
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 49,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 49,
            column: 16
          }
        }, {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 49,
            column: 73
          }
        }],
        line: 49
      },
      "2": {
        loc: {
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 62,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 58,
            column: 28
          }
        }, {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 61,
            column: 18
          }
        }],
        line: 58
      },
      "3": {
        loc: {
          start: {
            line: 63,
            column: 11
          },
          end: {
            line: 73,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 11
          },
          end: {
            line: 63,
            column: 28
          }
        }, {
          start: {
            line: 64,
            column: 12
          },
          end: {
            line: 72,
            column: 15
          }
        }],
        line: 63
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 11
          },
          end: {
            line: 78,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 11
          },
          end: {
            line: 74,
            column: 53
          }
        }, {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 77,
            column: 18
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 79,
            column: 11
          },
          end: {
            line: 83,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 11
          },
          end: {
            line: 79,
            column: 28
          }
        }, {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 82,
            column: 18
          }
        }],
        line: 79
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "412d608b8da33573caeb7bdeb71b96967c6ce3df"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_fummw3m42 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_fummw3m42();
import cn from 'classnames';
import React, { Suspense } from 'react';
import { lazily } from 'react-lazily';
import styles from './style.css';
var _ref = (cov_fummw3m42().s[0]++, lazily(function () {
    cov_fummw3m42().f[0]++;
    cov_fummw3m42().s[1]++;
    return import('./assets/american-express.svg');
  })),
  IconAmericanExpress = _ref.ReactComponent;
var _ref2 = (cov_fummw3m42().s[2]++, lazily(function () {
    cov_fummw3m42().f[1]++;
    cov_fummw3m42().s[3]++;
    return import('./assets/apple-pay-background.svg');
  })),
  IconApplePayBackground = _ref2.ReactComponent;
var _ref3 = (cov_fummw3m42().s[4]++, lazily(function () {
    cov_fummw3m42().f[2]++;
    cov_fummw3m42().s[5]++;
    return import('./assets/knet.svg');
  })),
  IconKnet = _ref3.ReactComponent;
var _ref4 = (cov_fummw3m42().s[6]++, lazily(function () {
    cov_fummw3m42().f[3]++;
    cov_fummw3m42().s[7]++;
    return import('./assets/mada.svg');
  })),
  IconMada = _ref4.ReactComponent;
var _ref5 = (cov_fummw3m42().s[8]++, lazily(function () {
    cov_fummw3m42().f[4]++;
    cov_fummw3m42().s[9]++;
    return import('./assets/master-card.svg');
  })),
  IconMastercard = _ref5.ReactComponent;
var _ref6 = (cov_fummw3m42().s[10]++, lazily(function () {
    cov_fummw3m42().f[5]++;
    cov_fummw3m42().s[11]++;
    return import('./assets/visa.svg');
  })),
  IconVisa = _ref6.ReactComponent;
var _ref7 = (cov_fummw3m42().s[12]++, lazily(function () {
    cov_fummw3m42().f[6]++;
    cov_fummw3m42().s[13]++;
    return import('./assets/google-pay.svg');
  })),
  GooglePay = _ref7.ReactComponent;
var APPLE_PAY_COUNTRIES_LIST = (cov_fummw3m42().s[14]++, ['UAE', 'KSA', 'KWT', 'QAT']);
cov_fummw3m42().s[15]++;
export var CreditCards = function CreditCards(_ref8) {
  var title = _ref8.title,
    className = _ref8.className,
    country = _ref8.country,
    fullWidth = _ref8.fullWidth;
  cov_fummw3m42().f[7]++;
  cov_fummw3m42().s[16]++;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.creditCard, (cov_fummw3m42().b[0][0]++, fullWidth) && (cov_fummw3m42().b[0][1]++, styles.fullWidthContainer), className)
  }, (cov_fummw3m42().b[1][0]++, !!title) && (cov_fummw3m42().b[1][1]++, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardTitle
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardContainerCard
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "mastercard-icon"
  }, /*#__PURE__*/React.createElement(IconMastercard, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "visa-icon"
  }, /*#__PURE__*/React.createElement(IconVisa, null)), (cov_fummw3m42().b[2][0]++, country === 'KWT') && (cov_fummw3m42().b[2][1]++, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "knet-icon"
  }, /*#__PURE__*/React.createElement(IconKnet, null))), (cov_fummw3m42().b[3][0]++, country === 'KSA') && (cov_fummw3m42().b[3][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "mada-icon"
  }, /*#__PURE__*/React.createElement(IconMada, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "amex-icon"
  }, /*#__PURE__*/React.createElement(IconAmericanExpress, null)))), (cov_fummw3m42().b[4][0]++, APPLE_PAY_COUNTRIES_LIST.includes(country)) && (cov_fummw3m42().b[4][1]++, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "applepay-icon"
  }, /*#__PURE__*/React.createElement(IconApplePayBackground, null))), (cov_fummw3m42().b[5][0]++, country === 'UAE') && (cov_fummw3m42().b[5][1]++, /*#__PURE__*/React.createElement("div", {
    className: styles.creditCardItem,
    "data-test": "google-pay-icon"
  }, /*#__PURE__*/React.createElement(GooglePay, null))))));
};